import { isValidNumber } from '@/utils/isValidNumber';

export const INVALID_CHART_LIST_RECID = 0;

export function isValidChartListRecid(chartListRecid: number) {
  return (
    isValidNumber(chartListRecid, { isRequiredToBeInteger: true, isRequiredToBeGreaterThanZero: true }) &&
    Number(chartListRecid) !== INVALID_CHART_LIST_RECID
  );
}
